import { withStyles } from '@material-ui/core';

import ImagesBlock from './component';
import styles from './styles';

export default withStyles(styles)(ImagesBlock);
